query GetMeetingsForReport(
    $limit: Int
    $sort: MeetingSortOrder
    $search: String
    $hasBookingsInLast90Days: Boolean
) {
    meetings(
        limit: $limit
        sort: $sort
        search: $search
        hasBookingsInLast90Days: $hasBookingsInLast90Days
    ) {
        id
        name
        primaryHost {
            id
            name
        }
        cohosts {
            id
            name
        }
        bookingsCountLast90Days
    }
}
